import { GenericRule } from '../../../../../../../utils/genericValidator.util';
import { OfflineOrderProduct } from '../../OfflineOrderProduct';

export class ValidatePriceInfoRule implements GenericRule<OfflineOrderProduct> {
  validateOrThrow(orderProduct: OfflineOrderProduct) {
    if (
      orderProduct.productColor.id !== orderProduct.metadata.productColorPriceInfo.productColorId
    ) {
      throw new Error('product color id does not match with product color price info');
    }
  }
}
